import L from "leaflet";
import { Position } from "@turf/turf";
import { AgroMap } from "@/features/map/utils/agromap";
import { MapType } from "@/features/map/utils/agromap.type";
import { Farm } from "@/features/farm/domain/farm.interface";

export class PointMap extends AgroMap {
  constructor(
    popupRef: React.RefObject<HTMLDivElement>,
    toolbarOptions: L.PM.ToolbarOptions,
    markerIcon: L.Icon<L.IconOptions> | L.DivIcon,
    private _type: MapType,
    private _farmerFarms?: Farm[],
    private _CurrentPoint?: Position,
    private _onStationPin?: (position: Position) => void
  ) {
    super(
      popupRef,
      toolbarOptions,
      _type !== "onlyShow",
      markerIcon,
      _CurrentPoint
    );
  }

  methodWhenClickEventFired(event: L.LeafletMouseEvent): void {
    const position: Position = [event.latlng.lat, event.latlng.lng];
    super.pinMarker(position);
    super.setPopup({ position });
    this._onStationPin!(position);
  }
}
